import { HandoverItemResponse } from '../../types/api-contracts/handoverItemResponse';
import { HandoverItem, ReasonForLeave } from '../../types/domain/handoverItem';
import { isHandoverStatus } from '../guards/isHandoverStatus';
import { isReasonForLeave } from '../guards/isReasonForLeave';

export const toDomainHandoverItem = (response: HandoverItemResponse): HandoverItem => {
  if (response.reason_for_leave && !isReasonForLeave(response.reason_for_leave)) {
    throw new Error(`Invalid reason for leave: ${response.reason_for_leave}`);
  }
  if (!isHandoverStatus(response.status)) {
    throw new Error(`Invalid handover status: ${response.status}`);
  }
  return {
    id: response.id,
    title: response.title,
    endDate: new Date(response.end_date),
    startDate: new Date(response.start_date),
    isCoveringEa: response.is_covering_ea,
    reasonForLeave: response.reason_for_leave as ReasonForLeave | undefined,
    groups: response.coverage_groups.map((group) => ({
      personCovered: group.covered_person,
      personCovering: group.covering_persons,
      isCovered: group.covering_persons.length > 0,
    })),
    status: response.status,
    isNew: response.is_new,
    completedAt: response.completed_at ? new Date(response.completed_at) : undefined,
    sentAt: response.sent_at ? new Date(response.sent_at) : undefined,
  };
};
